// extracted by mini-css-extract-plugin
module.exports = {"icons":"Styleguide_icons__VR5ad","iconBox":"Styleguide_iconBox__Vnhwl","icon":"Styleguide_icon__2tIIZ"};